import { useCallback, useRef, useState } from 'react';
import clsx from 'clsx';
import { HexColorPicker } from 'react-colorful';
import { useClickOutside } from '../utils/useClickOutside';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PopoverColorPicker(_ref) {
  var color = _ref.color,
      onChange = _ref.onChange,
      _ref$side = _ref.side,
      side = _ref$side === void 0 ? 'right' : _ref$side;
  var popover = useRef();

  var _useState = useState(false),
      isOpen = _useState[0],
      toggle = _useState[1];

  var close = useCallback(function () {
    return toggle(false);
  }, []);
  useClickOutside(popover, close);
  return /*#__PURE__*/_jsxs("div", {
    className: "relative",
    children: [/*#__PURE__*/_jsx("div", {
      className: "h-14 w-14 cursor-pointer rounded-2xl border-2 border-gray-100 shadow-md",
      style: {
        backgroundColor: color
      },
      onClick: function onClick() {
        return toggle(true);
      }
    }), isOpen && /*#__PURE__*/_jsx("div", {
      className: clsx('absolute right-0 top-[calc(100%+2px)] z-50 rounded-lg shadow-lg', {
        'left-0': side === 'left'
      }),
      ref: popover,
      children: /*#__PURE__*/_jsx(HexColorPicker, {
        color: color,
        onChange: onChange
      })
    })]
  });
}